import memoize from 'lodash/memoize';
import seedrandom from 'seedrandom';

const randomFromSeed = memoize((seed) => seedrandom(seed)());

export default randomFromSeed;
